import React from "react";

import ReactTooltip from "react-tooltip";

import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";

import { getProductImgUrl } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";

const ProductRowToolTip = ({ description, data, showTooltip, ...props }) => {
  return (
    <div data-tip className="ProductRowToolTip cursor-pointer flex" tabIndex={-1} {...props}>
      <MsxIcons name="info" className="text-gray-500" size="nano" />
      {showTooltip && (
        <ReactTooltip
          place="right"
          effect="solid"
          backgroundColor="#FFFFFF"
          textColor="rgb(31 41 55)"
          className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
        >
          <div className="flex flex-row">
            <div className="flex-col mr-1">
              {/* <img src={singleAxis} alt="linearAxis" className="max-h-[150px] max-w-[150px] w-35 h-35" /> */}
              <img src={getProductImgUrl(data?.axis?.axisGCR, 150, 150)} alt="Axis" />
            </div>
            <div className="flex flex-col mt-2">
              <div className="font-semibold text-blue-500">{description.name}</div>
              <div className="flex flex-row">
                <div className="mr-3">{t("cartesian.ui.axis_selection.profile_size")}:</div>
                <div className="font-semibold">{data?.axis?.profileDimension ? data?.axis?.profileDimension : "-"}</div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">{t("msizer.ui.drive_filters.drive_type")}:</div>
                <div className="font-semibold">{data?.axis?.driveType ? data?.axis?.driveType : "-"}</div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">Feed:</div>
                <div className="font-semibold">
                  {data?.axis?.driveType === "ball screw" ? data?.ballscrew?.ballscrewPitch : data?.axis?.feedConstant}
                </div>
              </div>
              <div className="flex flex-row">
                <div className="mr-3">{t("cartesian.ui.axis_selection.repeatability")}:</div>
                <div className="font-semibold">{data?.axis?.repeatability ? data?.axis?.repeatability : "-"}</div>
              </div>
            </div>
          </div>
        </ReactTooltip>
      )}
    </div>
  );
};

export default ProductRowToolTip;
